"use client";

import { Suspense, useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { useToast } from "@/hooks/use-toast";

function ErrorToastContent() {
  const { toast } = useToast();
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const error = searchParams.get("error");
      if (error) {
        toast({
          variant: "destructive",
          title: "Login Error",
          description: decodeURIComponent(error),
        });

        setTimeout(() => {
          const params = new URLSearchParams(window.location.search);
          params.delete("error");
          const newUrl =
            window.location.pathname +
            (params.toString() ? `?${params.toString()}` : "");
          router.replace(newUrl);
        }, 5000);
      }
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchParams, router, toast]);

  return null;
}

export default function ErrorToastHandler() {
  return (
    <Suspense fallback={null}>
      <ErrorToastContent />
    </Suspense>
  );
}